import { capitalize } from '@hotjar/insights-common/lib/string';
import * as adwords from './tools/adwords';
import * as facebook from './tools/facebook';
import * as googleAnalytics from './tools/google-analytics';
import * as quora from './tools/quora';
import * as twitter from './tools/twitter';
import * as unbounce from './tools/unbounce';

/**
 * Track a NEW ACCOUNT signup.
 */
export const newUserSignup = (plan: string): void => {
  if (plan) {
    googleAnalytics.trackSignup(capitalize(plan));
    adwords.trackSignup();
    facebook.trackSignup();
    twitter.trackSignup();
    quora.trackSignup();
    unbounce.trackSignup();
  }
};
